/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseWaterbureauRegistrationResponse } from '../backend/model';
// @ts-ignore
import type { WaterbureauRegistrationRequest } from '../backend/model';
/**
 * WaterbureauRegistrationApi - axios parameter creator
 * @export
 */
export const WaterbureauRegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new waterbureau with its OAuth2 client credentials.
         * @summary Register a new waterbureau
         * @param {WaterbureauRegistrationRequest} waterbureauRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWaterbureau: async (waterbureauRegistrationRequest: WaterbureauRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterbureauRegistrationRequest' is not null or undefined
            assertParamExists('registerWaterbureau', 'waterbureauRegistrationRequest', waterbureauRegistrationRequest)
            const localVarPath = `/api/admin/waterbureaus/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterbureauRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterbureauRegistrationApi - functional programming interface
 * @export
 */
export const WaterbureauRegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaterbureauRegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new waterbureau with its OAuth2 client credentials.
         * @summary Register a new waterbureau
         * @param {WaterbureauRegistrationRequest} waterbureauRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerWaterbureau(waterbureauRegistrationRequest: WaterbureauRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWaterbureauRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerWaterbureau(waterbureauRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaterbureauRegistrationApi.registerWaterbureau']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WaterbureauRegistrationApi - factory interface
 * @export
 */
export const WaterbureauRegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaterbureauRegistrationApiFp(configuration)
    return {
        /**
         * Creates a new waterbureau with its OAuth2 client credentials.
         * @summary Register a new waterbureau
         * @param {WaterbureauRegistrationRequest} waterbureauRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWaterbureau(waterbureauRegistrationRequest: WaterbureauRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWaterbureauRegistrationResponse> {
            return localVarFp.registerWaterbureau(waterbureauRegistrationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterbureauRegistrationApi - object-oriented interface
 * @export
 * @class WaterbureauRegistrationApi
 * @extends {BaseAPI}
 */
export class WaterbureauRegistrationApi extends BaseAPI {
    /**
     * Creates a new waterbureau with its OAuth2 client credentials.
     * @summary Register a new waterbureau
     * @param {WaterbureauRegistrationRequest} waterbureauRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterbureauRegistrationApi
     */
    public registerWaterbureau(waterbureauRegistrationRequest: WaterbureauRegistrationRequest, options?: RawAxiosRequestConfig) {
        return WaterbureauRegistrationApiFp(this.configuration).registerWaterbureau(waterbureauRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

